import { logPersonalizationServiceError } from '../telemetryHelpers/logDatapoints';
import { makeGetRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';

const getSuggestionUrl = 'ows/v1.0/Personalization/suggestions/Mail/SmartCompose';

export default async function fetchSmartComposePersonalization(): Promise<any> {
    const response = await makeGetRequest(
        getSuggestionUrl,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        undefined /* customHeaders */,
        undefined /* throwServiceError */,
        undefined /* includeCredentials */,
        'fetchSmartComposePersonalization' /* actionName */
    );

    try {
        if (response.ok) {
            const parsedResponse = await response.json();
            return parsedResponse;
        } else {
            logPersonalizationServiceError('error getting signals');
            trace.info('fetchSmartComposePersonalization: server reported error');
            return null;
        }
    } catch {
        logPersonalizationServiceError('error parsing signals');
        trace.info('fetchSmartComposePersonalization: exception parsing response');
        return null;
    }
}
